import React from 'react';
import './TabBar.scss';
import { useTranslation } from 'react-i18next';
import { ProjectOverviewViewEnum } from '../../../types/enums/ProjectOverviewViewEnum';

type TabBarProps = {
  onChangeProjectView: (activeView: ProjectOverviewViewEnum) => void;
  activeProjectView: ProjectOverviewViewEnum;
};

const TabBar = ({ onChangeProjectView, activeProjectView }: TabBarProps) => {
  const { t } = useTranslation();

  return (
    <div className="tabbar">
      <div className="tabbar-link-wrapper">
        <button
          className={`tabbar-link ${
            activeProjectView === ProjectOverviewViewEnum.Active ? 'active' : ''
          }`}
          onClick={() => onChangeProjectView(ProjectOverviewViewEnum.Active)}
        >
          {t('project-overview.tabbar.active-projects')}
        </button>
        <button
          className={`tabbar-link ${
            activeProjectView === ProjectOverviewViewEnum.Previous ||
            activeProjectView === ProjectOverviewViewEnum.Summary
              ? 'active'
              : ''
          }`}
          onClick={() => onChangeProjectView(ProjectOverviewViewEnum.Previous)}
        >
          {t('project-overview.tabbar.previous-projects')}
        </button>
      </div>
    </div>
  );
};

export default TabBar;
